export const PROCESS_ROUTES = Object.freeze({
    SEEDING: '/seeding',
    TRANSPLANTING: '/transplanting',
    DISCARDING: '/discarding',
    REPOSITIONING: '/repositioning',
    HARVESTING: '/harvesting',
    WEIGHING: '/weighing',
    REPORTING: '/reporting',
    PHOTO: '/photo'
});

export const MANAGEMENT_ROUTES = Object.freeze({
    SEED_TYPES: '/management/seed-types',
    CONTAINERS: '/management/containers',
    TENANT_MANAGEMENT: '/tenantmanagement',
    TEMPLATES: '/templates',
    GLOBAL_USER_MANAGEMENT: '/globalusermanagement',
    TENANT_USERS: '/management/tenantusers',
    CHANGE_PASSWORD: '/changepassword',
    PRODUCE_TYPES: '/management/produce-types',
});

export const ALLOWED_DEEP_LINK_PATHS = Object.freeze({
    PROCESS_START: '/processes/start',
    LAUNCH_MOBILE2B: '/launchMobile2B'
});

export const PROCESS_TEARDOWN_ROUTES = Object.freeze([
    ...Object.values(PROCESS_ROUTES),
    ALLOWED_DEEP_LINK_PATHS.PROCESS_START
]);

export const PROTECTED_PATH_PREFIXES = Object.freeze({
    SEED_TYPES: '/management/seed-types/list',
    CONTAINERS: '/management/containers/list',
    TENANT_MANAGEMENT: '/tenantmanagement',
    TEMPLATES: '/templates',
    GLOBAL_USER_MANAGEMENT: '/globalusermanagement',
    TENANT_USERS: '/management/tenantusers',
    CHANGE_PASSWORD: '/changepassword',
    PRODUCE_TYPES: '/management/produce-types/list',
    TASKS: '/tasks'
});

export const startsWithAny = (value, prefixes) => {
    for (const prefix of prefixes) {
        if (value.startsWith(prefix)) {
            return true;
        }
    }
    return false;
};
